import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { selectAllSettings } from '../../../modules/settings/store/slice';

import { doCreateSetting, doGetSettings, doUpdateSetting } from '../../../modules/settings/store/thunk';
import { Button } from '../../ui/button';
import { Save } from 'lucide-react';
import { Switch } from '../../ui/switch';

export const CompanySettings = () => {
  const dispatch = useDispatch<AppDispatch>();
  const user = useSelector((state: RootState) => state.auth.user);
  const companyId = user.selectedCompany.id;
  const existing = useSelector((state: RootState) => selectAllSettings(state));
  const [addressNotFound, setAddressNotFound] = useState(false);

  useEffect(() => {
    dispatch(
      doGetSettings({
        keyword: 'ADDRESS_NOT_FOUND',
        group: 'API',
        companyId: user.selectedCompany.id,
      }),
    );
  }, []);

  const handleSave = async () => {
    const updates = [];

    updates.push({
      id: existing.find((e) => e.keyword === 'ADDRESS_NOT_FOUND')?.id || null,
      keyword: 'ADDRESS_NOT_FOUND',
      value: addressNotFound ? 'true' : 'false',
      group: 'API',
      companyId: companyId,
    });

    try {
      await Promise.all(
        updates.map(async (u) => {
          if (u.id && u.value) {
            // if it existed and has a value => update it
            await dispatch(doUpdateSetting(u));
          } else if (u.value) {
            // if it didn't exist => create it
            await dispatch(doCreateSetting(u));
          }
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (existing) {
      setAddressNotFound(existing.find((e) => e.keyword === 'ADDRESS_NOT_FOUND')?.value === 'true');
    }
  }, [existing]);

  return (
    <div className="m-6">
      <h1 className="text-xl font-bold">Company Settings</h1>
      <p>
        Configure settings for <em>{user.selectedCompany?.name || user.company?.name || 'your company'}</em>
      </p>

      <div className="mt-8 flex flex-col space-y-4">
        <div className="flex justify-between rounded-lg border p-3 shadow-sm items-center w-[500px]">
          <div>
            <h3 className="font-bold">Address Not Found</h3>
            <p>
              When this is turned on, orders for which the address cannot be found will be created and can be retried in
              the dashboard
            </p>
          </div>
          <Switch id="address-not-found" checked={addressNotFound} onCheckedChange={setAddressNotFound} />
        </div>
      </div>
      <div className="w-[500px] flex justify-end mt-8 gap-4">
        <Button className="px-8" onClick={handleSave}>
          <Save /> Save
        </Button>
      </div>
    </div>
  );
};
